import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import ProjectService from "./ProjectService";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

type ProjectDropdownProps = {
    page?: string
    topBar?:boolean
}
const ProjectDropdown = (props: ProjectDropdownProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [selectProject, setSelectedProject] = useState<any>(null);
    const [projects, setProjects] = useState<any>([]);
    const projectService = new ProjectService();
    const { projectId } = useParams<any>();

    const findValue = (jsonArray: { name: string, code: number }[], nameToFind: any): any | null => {
        for (let i = 0; i < jsonArray.length; i++) {
            if (jsonArray[i].code === nameToFind) {
                return jsonArray[i];
            }
        }
        return null; // Return null if the name is not found
    }

    useEffect(() => {
        let projectArr = [{ name: t("all_projects"), code: 0 }];
        projectService.getAssignedDevices(localStorage.getItem('userId'), "").then((response) => {
            response.map((val: any) => {
                let json: any = {
                    name: val['project']['project_name'],
                    code: val['project']['id']
                }
                projectArr.push(json);
            })
            setProjects(projectArr)
            if (window.location.pathname === '/' || window.location.pathname === '/create-project') {
                setSelectedProject({ name: t("all_projects"), code: 0 })
            }
            else {
                setSelectedProject(findValue(projectArr, projectId))
            }

        });
    }, [window.location.pathname])
    return (
        <>
            <div className="grid">
                <div className={props.topBar ? 'col-12' :"sm:col-3"}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Dropdown className="w-full md:w-18rem m-1" filter style={{ width: props.page !== 'all-projects' && '100%' }} value={selectProject} onChange={(e) => {
                            setSelectedProject(e.value);
                            const dropdownData = JSON.stringify({code: e.value.code, name: e.value.name})
                            localStorage.setItem('projectDropdown', dropdownData);
                            if (e.value.code === 0)
                                navigate('/')
                            else
                                navigate('/project/' + e.value.code)
                        }} options={projects} optionLabel="name" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProjectDropdown;